import { Flex, Text, TextContainer } from "@wayflyer/flyui";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";

import { MESSAGES } from "../message-definitions";

export const BusinessModelGeoLetDown = ({
  eligibilityLink,
  isNewSetupFlow,
}: {
  eligibilityLink: ReactNode;
  isNewSetupFlow: boolean;
}) => {
  const intl = useIntl();

  return (
    <Flex direction="column" gap="4">
      {isNewSetupFlow ? (
        <TextContainer>{intl.formatMessage(MESSAGES.letDownReasonBusinessModelGeoMultiSelect)}</TextContainer>
      ) : (
        <TextContainer>{intl.formatMessage(MESSAGES.letDownReasonBusinessModelGeo)}</TextContainer>
      )}
      <Text>{eligibilityLink}</Text>
    </Flex>
  );
};
